const SCRIPT_ID = "gcaptcha-v3";

export function loadRecaptcha(siteKey) {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") return reject(new Error("No window"));
    if (window.grecaptcha) return resolve(window.grecaptcha);

    const existing = document.getElementById(SCRIPT_ID);
    const waitFor = () =>
      window.grecaptcha ? resolve(window.grecaptcha) : setTimeout(waitFor, 50);
    if (existing) return waitFor();

    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    const key = encodeURIComponent(siteKey);
    s.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
    s.async = true;
    s.defer = true;
    s.onload = () => (window.grecaptcha ? resolve(window.grecaptcha) : reject(new Error("grecaptcha not available")));
    s.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
    document.head.appendChild(s);
  });
}

export async function getRecaptchaToken(action) {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  if (!siteKey) throw new Error("Missing REACT_APP_RECAPTCHA_SITE_KEY");
  const grecaptcha = await loadRecaptcha(siteKey);
  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(siteKey, { action })
        .then(resolve)
        .catch(reject);
    });
  });
}